import {
  OutputStreamStatsEntry,
  OutputStreamStatsResponse,
} from "@arrowsup/platform-dtos";
import { useQuery } from "@tanstack/react-query";
import { useEffectiveOrgId } from "../auth/use-effective-org-id";
import { useContext } from "react";
import { ApiContext } from "../api/api-context";
import * as ss from "superstruct";

export const useOutputStreamStats = () => {
  const { api } = useContext(ApiContext);
  const orgId = useEffectiveOrgId();

  const { data, isLoading } = useQuery({
    queryKey: ["output-stream-stats", orgId],
    queryFn: async ({ signal }) => {
      const resp = await api.get<unknown>(
        "/api/conversion/output-stream-stats",
        { signal }
      );
      const [err, validated] = ss.validate(
        resp.data,
        OutputStreamStatsResponse
      );
      if (err) {
        throw new Error(`Invalid output stream stats response: ${err.message}`);
      }
      return validated;
    },
  });

  const statsMap = new Map<number, OutputStreamStatsEntry>();
  if (data) {
    for (const entry of data) {
      statsMap.set(entry.outputStreamId, entry);
    }
  }

  return { statsMap, isLoading };
};
